(function ($, App, Utils) {
    'use strict';

    var logger = new Logger('GTM');

    Utils.add('Gtm', {

        push: function (data) {
            if (typeof dataLayer !== 'undefined') {
                logger.debug("[push]", data);
                dataLayer.push(data);
            }
        },

        criteoEvent: function (data) {
            // Criteo GTM analytics seo events
            if (data && data.page) {
                logger.debug('criteo page: ' + data.page);
                var criteoObj = {
                    event: data.event,
                    crto: {
                        email: data.email
                    }
                };
                if (data.page !== 'home') {
                    criteoObj.crto.products = data.products // data.products is array of strings. For cart and ty page, each product must contain price and qty as well as the id.
                }
                if (data.page === 'thankyou') {
                    criteoObj.crto.transactionid = data.orderNumber.toString();
                }

                logger.debug('criteoObj: ' + JSON.stringify(criteoObj));
                this.push(criteoObj);
            } else {
                logger.error('criteoEvent called with no data nor page passed');
            }
        },
        
        checkoutEvent: function (checkoutData) {
            // Tracking checkout GTM events
            logger.debug('Tracking checkout event');
            var checkoutObj = {
                categoria: 'Prenotazione cesti avvenuta',
                azione: 'Conferma prenotazione',
                etichetta: 'Catalogo Natale 2019'
            };

            logger.debug('checkoutObj: ' + JSON.stringify(checkoutObj));
            this.push(checkoutObj);
        },

        init: function () {
        	
        }
    });

})(jQuery, window.App, window.App.Utils);
